import $ from 'jquery';

$(function () {

    $('body').on('click','.js-trigger-demo-modal', function(e) {
        e.preventDefault();
        $('.js-demo-modal').addClass('active');
        $('body').css('overflow', 'hidden');
    });

    $('.js-trigger-callback-modal').on('click', function(e) {
        e.preventDefault();
        $('.js-callback-modal').addClass('active');
    });

    $('.js-trigger-book-modal').on('click', function(e) {
        e.preventDefault();
        $('.js-book-modal').addClass('active');
    });

    $('.js-trigger-video-modal').on('click', function(e) {
        e.preventDefault();
        $('.js-video-modal').addClass('active');
        $('body').css('overflow', 'hidden');

        const youTubeIframe = $('.js-video-modal iframe');
        const videoSrc = youTubeIframe.attr('src') + '&autoplay=1';
        youTubeIframe.attr('src', videoSrc);

    });

    $('.js-modal-close').on('click', function() {
        $('.js-demo-modal').removeClass('active');
        $('.js-callback-modal').removeClass('active');
        $('.js-book-modal').removeClass('active');
        $('.js-limit-modal').removeClass('active');
        $('.js-video-modal').removeClass('active');
        $('body').css('overflow', 'visible');
        resetYouTubeVideo();
    });

    function resetYouTubeVideo() {

        const youTubeIframe = $('.js-video-modal iframe');

        if (youTubeIframe.length > 0) {
            let videoSrc = youTubeIframe.attr('src');
            videoSrc = videoSrc.replace('&autoplay=1', '');
            youTubeIframe.attr('src', '');
            youTubeIframe.attr('src', videoSrc);
        }
    }

});
